import { MessageCircle } from "lucide-react";
import { whatsappLink } from "@/data/site";
import { externalLinkProps } from "@/lib/security";

export const WhatsAppFab = () => (
  <a
    href={whatsappLink()}
    {...externalLinkProps}
    aria-label="Discuter sur WhatsApp"
    className="fixed bottom-6 right-6 z-40 inline-flex h-14 items-center gap-3 rounded-full bg-[#25D366] px-5 text-[#052E16] shadow-lg transition-all duration-300 hover:scale-[1.03] hover:bg-[#20BD5A] hover:shadow-xl"
  >
    <MessageCircle className="size-5" strokeWidth={2.2} aria-hidden />
    <span className="hidden text-sm font-medium sm:inline">WhatsApp</span>
  </a>
);
